var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-wrapper" }, [
    _c(
      "div",
      { staticClass: "sidebar-wrapper" },
      [
        _vm.getAppTypeUserLogin == _vm.appType.PARENT
          ? _c("MenuParent")
          : _vm._e(),
        _vm.getAppTypeUserLogin == _vm.appType.SCHOOL
          ? _c("MenuSchool")
          : _vm._e(),
        _vm.getAppTypeUserLogin == _vm.appType.TEACHER
          ? _c("MenuTeacher")
          : _vm._e(),
        _vm.getAppTypeUserLogin == _vm.appType.SUPPER_SCHOOL
          ? _c("MenuSuperSchool")
          : _vm._e(),
        _vm.getAppTypeUserLogin == _vm.appType.SUPPER_SYSTEM ||
        _vm.getAppTypeUserLogin == _vm.appType.SYSTEM
          ? _c("MenuAdminManagement")
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content-wrapper" },
      [_c("navbar"), _c("app-main")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }